module.exports = __webpack_public_path__ + "img/mb-wellness-points.60cf3204.png";